/**
 * PricingToggle - Toggle mensuel/annuel stylisé dark theme (CSS only)
 */

import { cn } from "@/lib/utils";

interface PricingToggleProps {
  billingPeriod: "monthly" | "yearly";
  onToggle: (period: "monthly" | "yearly") => void;
}

export function PricingToggle({ billingPeriod, onToggle }: PricingToggleProps) {
  return (
    <div className="flex items-center justify-center gap-4">
      <div className="relative inline-flex items-center p-1 rounded-full bg-white/[0.05] border border-white/[0.1]">
        {/* Background slider - CSS transition */}
        <div
          className={cn(
            "absolute h-10 rounded-full bg-[#F59E0B] transition-all duration-300 ease-out",
            billingPeriod === "monthly"
              ? "left-1 w-[104px]"
              : "left-[108px] w-[124px]"
          )}
        />

        {/* Monthly button */}
        <button
          onClick={() => onToggle("monthly")}
          className={cn(
            "relative z-10 px-5 py-2 rounded-full text-sm font-medium transition-colors duration-200",
            billingPeriod === "monthly"
              ? "text-[#0A0A0F]"
              : "text-white/60 hover:text-white"
          )}
        >
          Mensuel
        </button>

        {/* Yearly button */}
        <button
          onClick={() => onToggle("yearly")}
          className={cn(
            "relative z-10 px-5 py-2 rounded-full text-sm font-medium transition-colors duration-200 flex items-center gap-2",
            billingPeriod === "yearly"
              ? "text-[#0A0A0F]"
              : "text-white/60 hover:text-white"
          )}
        >
          Annuel
          <span
            className={cn(
              "text-xs px-1.5 py-0.5 rounded-full font-semibold transition-colors duration-200",
              billingPeriod === "yearly"
                ? "bg-[#0A0A0F]/20 text-[#0A0A0F]"
                : "bg-[#10B981]/20 text-[#10B981]"
            )}
          >
            -20%
          </span>
        </button>
      </div>
    </div>
  );
}

export default PricingToggle;
